export default __webpack_public_path__ + "static/media/E_04_01_bg.03dec663.mp4";